<template>
  <div class="mm-page-main" v-loading="mso_id==0" :element-loading-text="'請先添加牌照MSO和門店'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <div v-show="!isdetail">
      <div class="page-header">
        <div class="page-title">買入交易管理</div>
        <div>
          <el-link @click="gotoruter('/BuyBusinessAdd')" type="primary"><i class="el-icon-circle-plus"></i>添加買入交易</el-link>
        </div>
      </div>
      <search :form="form" @submit="getdata"></search>
      <div style="height:15px"></div>
      <div v-if="stores.length>0" class="mm-tabs">
        <div class="mm-tabsulbox">
          <div @click="tableft" class="tabsleftico"><i class="el-icon-arrow-left"></i></div>
          <ul :style="transform" class="mm-tabs-card">
            <li @click.stop="changestore(0)" :class="{active:store_id == 0}">全部</li>
            <li @click.stop="changestore(store.id)" :class="{active:store_id == store.id}" v-for="(store,index) in stores" :key="index">{{store.name}}</li>
          </ul>
          <div @click="tabright" class="tabsrightico"><i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="mm-tabs-content">
          <div class="pagemain">
            <div class="mainheader" style="padding-top:0;">
              <div class="radio-group-box">
                <div class="radio-group-title">業務類別：</div>
                <div>
                  <el-radio-group @change="changetype" v-model="form.type">
                    <el-radio-button label="-1">全部</el-radio-button>
                    <el-radio-button label="0">兌換</el-radio-button>
                    <el-radio-button label="1">匯款</el-radio-button>
                    <el-radio-button label="2">內部記賬</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <div class="downexcel">
                <el-link @click="exportExcel()" icon="el-icon-download">下載EXCEL</el-link>
              </div>
            </div>

            <div class="pagetablebox">
              <el-table :data="data" border :header-cell-style="{background:'#FAFAFA'}" sortable>
                <el-table-column width="200" prop="ordernum" label="交易編號" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">交易編號</div>
                    <span :class="{'unlink':scope.row.status==5}">B{{scope.row.businessnum}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="mode" label="交易方式" align="center" sortable>
                  <template slot-scope="scope">
                    <div class="phonecel">交易方式</div>
                    <span :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode== 0">現金</span>
                    <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.mode== 1">銀行轉賬</span>
                    <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.mode== 2">特別賬戶</span>
                  </template>
                </el-table-column>
                <el-table-column prop="ordertype" label="類別" align="center" sortable>
                  <template slot-scope="scope">
                    <div class="phonecel">類別</div>
                    <span :class="{'unlink':scope.row.status==5}" v-if="scope.row.type == 0">兌換</span>
                    <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.type == 1">匯款</span>
                    <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.type == 2">內部記賬</span>
                  </template>
                </el-table-column>
                <el-table-column prop="addtime" label="時間" align="center" sortable>
                  <template slot-scope="scope">
                    <div class="phonecel">時間</div>
                    <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>

                  </template>

                </el-table-column>
                <el-table-column prop="store_name" width="250px" label="交易賬戶" align="center" sortable>
                  <template slot-scope="scope">
                    <div class="phonecel">交易賬戶</div>
                    <div class="mm-text-right" :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==0">{{scope.row.store_name}} {{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
                    <div class="mm-text-right" :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==1">
                      <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.bank_account.id">
                        <div>{{scope.row.bank_account.account_name}} {{addSpace(scope.row.bank_account.account_num)}} </div>
                        <div>{{scope.row.bank_account.bankname}} </div>
                        <div>{{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
                      </div>
                      <div v-else>未關聯賬戶</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="買入金額" align="center" sortable>
                  <template slot-scope="scope">
                    <div class="phonecel">買入金額</div>
                    <div :class="{'unlink':scope.row.status==5}">{{scope.row.currency_short_name}} {{tomoney(scope.row.money)}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="store_name" label="狀態" align="center" sortable>
                  <template slot-scope="scope">
                    <div class="phonecel">狀態</div>
                    <statustext :status="scope.row.status"></statustext>
                  </template>

                </el-table-column>
                <el-table-column prop="files" label="水單" align="center" sortable>
                  <template slot-scope="scope">
                    <div class="phonecel">水單</div>
                    <div v-if="scope.row.files.length>0" class="flex">
                      <img :src="apiurl+scope.row.files[0].fileurl" height="35px" class="mr10" @click="showimg_url=apiurl+scope.row.files[0].fileurl;showimg_dialog = true;">
                      <el-link v-if="scope.row.files.length>1" @click="Details(scope.row.id)">還有{{scope.row.files.length-1}}張</el-link>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="store_name" label="關聯訂單" align="center" sortable>
                  <template slot-scope="scope">
                    <div class="phonecel">關聯訂單</div>
                    <span :class="{'unlink':scope.row.status==5}" v-if="scope.row.ordertype == 0">
                      <el-link @click="orderDetails(scope.row.order_id)">{{scope.row.store_short}}-C{{scope.row.ordernum}}</el-link>
                    </span>
                    <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.ordertype == 1">
                      <el-link @click="orderDetails(scope.row.order_id)">{{scope.row.store_short}}-R{{scope.row.ordernum}}</el-link>
                    </span>
                    <span :class="{'unlink':scope.row.status==5}" v-else-if="scope.row.ordertype == 2">
                      <el-link @click="orderDetails(scope.row.order_id)">{{scope.row.store_short}}-I{{scope.row.ordernum}}</el-link>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="status" width="90px;" label="操作" align="center">
                  <template slot-scope="scope">
                    <div class="phonecel">操作</div>
                    <el-link @click="Details(scope.row.id)"><i class="el-icon-circle-plus-outline"></i>詳細</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="page-bottom">
              <div>
                <div class="stat-box">
                  <div class="stat-item">
                    <svg class="icon svg-icon" aria-hidden="true">
                      <use xlink:href="#icon-huobi"></use>
                    </svg>
                    總金額 {{tomoney(totaldata.total_money)}} HKD
                  </div>
                  <div class="stat-item">
                    總手續費 {{totaldata.total_fee}} HKD
                  </div>
                </div>
                <div class="stat-box">
                  <div class="stat-item"><i class="el-icon-pie-chart"></i> 總筆數：{{totaldata.total_num}} 筆</div>
                  <div class="stat-item"> Pending：{{totaldata.total_pending}} 筆</div>
                  <div class="stat-item"> Approved：{{totaldata.total_approved}} 筆</div>
                  <div class="stat-item"> Processing：{{totaldata.total_processing}} 筆</div>
                  <div class="stat-item"> Successful：{{totaldata.total_success}} 筆</div>
                  <div class="stat-item"> Failed：{{totaldata.total_failed}} 筆</div>
                  <div class="stat-item"> Delete：{{totaldata.total_delete}} 筆</div>
                </div>
              </div>
              <div></div>
              <div>
                <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 水單查看 -->
      <el-dialog :visible.sync="showimg_dialog" height="80%" center>
        <img :src="showimg_url" alt="" style="width:100%;margin:0 auto;">
      </el-dialog>
    </div>
    <div v-if="isdetail">
      <buybuinessdetails :visible.sync="isdetail" @refresh="getdata" :id="id"></buybuinessdetails>
    </div>
  </div>

</template>

<script>
import search from "./components/Search.vue";
import buybuinessdetails from "@/components/BuyBusinessDetails.vue";
import statustext from "@/components/StatusText.vue";
import XLSX from 'xlsx';
export default {
  components: {
    search,
    buybuinessdetails,
    statustext
  },
  data () {
    return {
      mso_id: 0,
      id: 0,
      isdetail: false,
      store_id: 0,
      stores: [],
      transform: '',
      transformnum: 0,
      totaldata: [],
      showimg_url: '',
      showimg_dialog: false,
      data: [],
      page: 1,
      pagesize: 10,
      pager: [],
      form: {
        type: -1,
        mode: '-1',
        currency_id: '-1',
        status: '-1',
        startmoney: '',
        endmoney: '',
        starttime: '',
        endtime: '',
        businessnum: '',
      },
    };
  },
  methods: {
    exportExcel () {
      this.$confirm("確認下載EXCEL嗎？", '詢問', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.excel();
      }).catch(error => {
        console.log(error);
      });
    },
    excel () {
      let form = this.form;
      this.post('/api/business/buyindex', {
        buytype: 0,
        page: this.page,
        pagesize: this.pagesize,
        store_id: this.store_id,
        export_excel: 1,
        ...this.form
      }).then(response => {
        if (response.info.length > 0) {
          this.createExcel(response.info);
        } else {
          // 提醒信息
          this.$notify({
            message: '暫無相關數據',
            type: 'error',
            duration: 3000,
            offset: 160
          });
        }
      }).catch(error => { console.log(error) });
      return false;

    },
    createExcel (data) {
      //数据表格
      var table = [];
      table.push({
        A: "單號",
        B: "日期",
        C: "交易方式",
        D: "類別",
        E: "交易賬戶",
        F: "交易戶主",
        G: "交易銀行",
        H: "交易金額",
        I: "交易貨幣",
        J: "狀態",
      });
      data.forEach((item)=> {
        let businessnum = (item.buytype==0?'B':'S') + item.businessnum;
        let mode = item.mode == 0 ? '現金' : (item.mode == 1 ? '銀行轉賬' : '特別賬戶');
        let type = item.type == 0 ? '兌換' : (item.type == 1 ? '匯款' : '內部記賬');
        let account = '';
        let account_owner = '';
        let account_bank= '';
        if(item.mode==0){
          account = item.store_name+' '+item.currency_short_name+' '+item.currency_name;
        }else if(item.mode==1){
          account = item.bank_account.account_num;
          account_owner = item.bank_account.account_name;
          account_bank = item.bank_account.bankname;
        }
        let status = this.statusText(item.status);
        var row = {
          A: businessnum,
          B: item.addtime,
          C: mode,
          D: type,
          E: account,
          F: account_owner,
          G: account_bank,
          H: item.money,
          I: item.currency_short_name,
          J: status,
        };
        table.push(row);
      });
      //创建book
      var wb = XLSX.utils.book_new();
      //json转sheet
      var ws = XLSX.utils.json_to_sheet(table, { header: ["A", "B", "C", "D", "E", "F", "G", "H", "I","J"], skipHeader: true });
      //设置列宽
      ws['!cols'] = [
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 25 },
        { width: 15 },
        { width: 10 }
      ];
      var timestamp = (new Date()).getTime();
      //sheet写入book
      XLSX.utils.book_append_sheet(wb, ws, "交易單列表");
      //输出
      XLSX.writeFile(wb, "businesslist" + timestamp + ".xlsx");
    },
    tableft () {
      let num = this.transformnum - 1;
      if (num >= 0) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }

    },
    tabright () {
      let num = this.transformnum + 1;
      if (num < this.stores.length - 1) {
        this.transform = 'transform:translate3d(' + (-85 * num) + 'px,0,0)';
        this.transformnum = num;
      }
    },
    gotoruter (name) {
      this.$router.push(name)
    },
    changetype () {
      this.getdata();
    },
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    getdata () {
      this.post('/api/business/buyindex', {
        buytype: 0,
        page: this.page,
        pagesize: this.pagesize,
        store_id: this.store_id,
        ...this.form
      }).then((res) => {
        if (res.status == 'success') {
          this.pager = res.pager;
          this.data = res.info;
          this.totaldata = res.totaldata;
        } else {
          this.pager = [];
          this.data = [];
          this.totaldata = [];
        }
      }).catch((err) => {

        console.log(err)
      })
    },
    getstore () {

      this.post('/api/store/index', {

      }).then((res) => {
        this.stores = res;
      }).catch((err) => {

        console.log(err)
      }).then(() => {
        this.getdata();
      })


    },
    changestore (store_id) {
      this.store_id = store_id;
      this.getdata();
    },
    Details (id) {
      this.id = id;
      this.isdetail = true;
      // this.$router.push({
      //   name: '/BuyBusinessDetails',
      //   path: '/BuyBusinessDetails',
      //   params: {
      //     id: id
      //   }
      // })
    },
    orderDetails (id) {
      this.$router.push({
        name: '/OrderDetails',
        path: '/OrderDetails',
        query: {
          id: id
        }
      })
    }

  },
  created () {
    this.mso_id = sessionStorage.getItem('mso_id');
    this.getstore();
  },
  watch: {
    'form': { // 動態監控利率變化
      handler: function (val) {
        this.getdata();
      },
      deep: true
    },
  }
};
</script>
<style scoped>
.mainheader {
  padding-top: 20px;
}
.pagetablebox {
  padding: 20px 0;
}
.radio-group-box {
  display: flex;
  align-items: center;
}
.mr10 {
  margin-right: 10px;
}
.flex {
  display: flex;
}
.stat-box {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 15px 0;
}
.stat-item {
  margin-right: 15px;
  font-size: 14px;
  font-weight: 500;
}
</style>
